var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import { useState, useEffect } from "react";
import { ChatWidget } from "./ChatWidget";
import * as Frigade from "@frigade/react";
import { useFlow } from "@frigade/react";
import { fetchMeUser } from "./api";
// Frigade API key
var FRIGADE_API_KEY = process.env.REACT_APP_FRIGADE_API_KEY || "";
// Frigade Tour component for first prompt
var FrigadePromptTour = function () {
    return (_jsx(Frigade.Tour, { flowId: "flow_scCuM45T", container: document.body, sequential: false, dismissible: true, spotlight: false, defaultOpen: true, side: "top" }));
};
// Frigade Tour component for configure button
var FrigadeConfigureTour = function (_a) {
    var onConfigureClick = _a.onConfigureClick;
    var flow = useFlow("flow_dFqYRFiO").flow;
    // Set up click listener on configure button to dismiss tour
    useEffect(function () {
        var handleClick = function () {
            if (flow) {
                flow.complete();
            }
            onConfigureClick();
        };
        var configureButton = document.querySelector('[data-tour-id="configure-button"]');
        if (configureButton) {
            configureButton.addEventListener('click', handleClick);
        }
        return function () {
            if (configureButton) {
                configureButton.removeEventListener('click', handleClick);
            }
        };
    }, [flow, onConfigureClick]);
    return (_jsx(Frigade.Tour, { flowId: "flow_dFqYRFiO", container: document.body, sequential: false, dismissible: true, spotlight: false, defaultOpen: true }));
};
var App = function () {
    var _a = useState(""), authToken = _a[0], setAuthToken = _a[1];
    var _b = useState(""), apiBaseURL = _b[0], setApiBaseURL = _b[1];
    var _c = useState(true), useDummyResponse = _c[0], setUseDummyResponse = _c[1];
    var _d = useState(undefined), customization = _d[0], setCustomization = _d[1];
    var _e = useState(false), isReady = _e[0], setIsReady = _e[1];
    // User data for Frigade
    var _f = useState(null), meUser = _f[0], setMeUser = _f[1];
    // Track whether messages exist for showing appropriate tour
    var _g = useState(false), hasMessages = _g[0], setHasMessages = _g[1];
    useEffect(function () {
        // Listen for configuration from parent window
        var handleMessage = function (event) { return __awaiter(void 0, void 0, void 0, function () {
            var _a, messageType, authToken, apiBaseURL, useDummyResponse, customization, fetchedUser, error_1;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        _a = event.data, messageType = _a.messageType, authToken = _a.authToken, apiBaseURL = _a.apiBaseURL, useDummyResponse = _a.useDummyResponse, customization = _a.customization;
                        if (!(messageType === "SEND_INFO_TO_IFRAME")) return [3 /*break*/, 7];
                        setAuthToken(authToken);
                        setApiBaseURL(apiBaseURL);
                        setUseDummyResponse(useDummyResponse !== null && useDummyResponse !== void 0 ? useDummyResponse : true);
                        setCustomization(customization);
                        if (!(authToken && apiBaseURL)) return [3 /*break*/, 5];
                        _b.label = 1;
                    case 1:
                        _b.trys.push([1, 3, , 4]);
                        return [4 /*yield*/, fetchMeUser(apiBaseURL, authToken)];
                    case 2:
                        fetchedUser = _b.sent();
                        setMeUser(fetchedUser);
                        return [3 /*break*/, 4];
                    case 3:
                        error_1 = _b.sent();
                        console.error('Failed to fetch user. Frigade may not load properly:', error_1);
                        return [3 /*break*/, 4];
                    case 4: return [3 /*break*/, 6];
                    case 5:
                        console.error('Cannot fetch user: missing authToken or apiBaseURL. Frigade will not load.');
                        _b.label = 6;
                    case 6:
                        setIsReady(true);
                        _b.label = 7;
                    case 7:
                        if (messageType === "CLOSE_CHAT") {
                            // Handle chat close if needed
                        }
                        return [2 /*return*/];
                }
            });
        }); };
        window.addEventListener("message", handleMessage);
        // Notify parent that chat is ready
        window.parent.postMessage({
            messageType: "CHAT_READY",
        }, "*");
        return function () {
            window.removeEventListener("message", handleMessage);
        };
    }, []);
    if (!isReady) {
        return null;
    }
    var chatContent = (_jsx("div", __assign({ className: "p-8 h-full w-full flex items-center justify-center bg-transparent overflow-hidden" }, { children: _jsx(ChatWidget, { authToken: authToken, apiBaseURL: apiBaseURL, useDummyResponse: useDummyResponse, customization: customization, onMessagesChange: setHasMessages, meUser: meUser }) })));
    // Render Frigade as sibling to chatContent to avoid theme conflicts
    // Show prompt tour when no messages, configure tour after messages
    var frigadeComponent = FRIGADE_API_KEY && (meUser === null || meUser === void 0 ? void 0 : meUser.id) ? (_jsx(Frigade.Provider, __assign({ apiKey: FRIGADE_API_KEY, userId: meUser.id, userProperties: {
            email: meUser.email,
            name: meUser.name,
        }, theme: {
            colors: {
                primary: {
                    background: '#203237',
                    foreground: '#FFFFFF',
                    surface: '#6B8A92', // Medium teal for beacon/indicator (lighter)
                },
                neutral: {
                    background: '#FFFFFF',
                    foreground: '#203237',
                    border: '#EAEAE9',
                    surface: '#F4F4F4', // Light gray surfaces/hover states
                },
            },
        } }, { children: hasMessages ? _jsx(FrigadeConfigureTour, { onConfigureClick: function () { } }) : _jsx(FrigadePromptTour, {}) }))) : null;
    return (_jsxs(_Fragment, { children: [frigadeComponent, chatContent] }));
};
export default App;
